import { useFormikContext } from 'formik';

import FormError from './common/FormError';

const FieldError = (props) => {
  const { name, label } = props;
  const { id = `c7-${name}` } = props;
  const formikContext = useFormikContext();
  const { touched, errors } = formikContext;
  const error = errors[name];
  const touch = touched[name];
  const errorId = `${id}-error`;

  return <FormError touch={touch} error={error} id={errorId} label={label} />;
};

export default FieldError;
